module.exports = __webpack_public_path__ + "img/sld_mfm_inv_8_t1_b1_dark.ca40d04d.svg";